import { useQuery } from '@tanstack/react-query';
import {
  EntitlementsApi,
  type WorkspaceEntitlementsDto,
} from '@up2stay/up2promo-api-client';

export const CUSTOM_ROLES_FEATURE = 'feature.custom_roles';

export const workspaceEntitlementsQueryKey = (workspaceId?: string) =>
  ['workspace-entitlements', workspaceId] as const;

export function useWorkspaceEntitlements(workspaceId?: string) {
  return useQuery({
    queryKey: workspaceEntitlementsQueryKey(workspaceId),
    queryFn: async (): Promise<WorkspaceEntitlementsDto | null> => {
      if (!workspaceId) return null;
      const response = await EntitlementsApi.getEntitlements({
        path: { workspaceId },
      });
      return response.data ?? null;
    },
    enabled: !!workspaceId,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useHasCustomRolesFeature(workspaceId?: string): {
  isLoading: boolean;
  enabled: boolean;
} {
  const { data, isLoading } = useWorkspaceEntitlements(workspaceId);
  return {
    isLoading,
    enabled: data?.features?.[CUSTOM_ROLES_FEATURE] === true,
  };
}
